import React, {Component} from 'react'

import BottomButton from './../../ui/BottomButton'
import Typography from '@material-ui/core/Typography'

import Screen from './../../ui/Screen'
import PaperBlock from './../../ui/PaperBlock'
import ErrorMessageDialog from './../../ui/ErrorMessageDialog'

import ListItems from "./ShowItemsScreen/ListItems"
import ControlPanel from "./ShowItemsScreen/ControlPanel"

import CompleteShowDialog from "./ShowItemsScreen/CompleteShowDialog"
import SelectItemDialog from "./../../inventory/SelectItemDialog"
import SelectTemplateDialog from "./../../templates/SelectTemplateDialog"
import TemplateAmountDialog from "./ShowItemsScreen/TemplateAmountDialog"
import SetItemAmountDialog from "./ShowItemsScreen/SetItemAmountDialog"
import DeleteItemDialog from "./ShowItemsScreen/DeleteItemDialog"
import CommentShowDialog from "./ShowItemsScreen/CommentShowDialog"
import ReportDialog from "./ShowItemsScreen/ReportDialog"

import CommentPanel from './ShowItemsScreen/CommentPanel'

import Cookie from "./../../Cookie"
import {config} from "./../../config"
import api from "./../../api.js"

import CreatePurchaseDialog from '../../purchase/PurchaseScreen/CreatePurchaseDialog.js'
import SelectPurchaseDialog from '../../purchase/SelectPurchaseDialog.js'
import SelectPurchaseTypeDialog from './ShowItemsScreen/SelectPurchaseTypeDialog.js'

/**
 * <ShowItemsScreen show onClose = {} />
 * 
 * onCreatePurchase(items)
 * onAttachPurchase(items)
 * onClose
 */

class ShowItemsScreen extends Component {

	constructor(props) {

		super(props)

		this.state = {
			show: undefined,
			selected: undefined,
			dialog: undefined,
			shopping_list: [],
		}
	
		this.handleAttachItem = this.handleAttachItem.bind(this)
		this.handleEditItem = this.handleEditItem.bind(this)
		this.handleRemoveItem = this.handleRemoveItem.bind(this)
		this.handleCompleteShow = this.handleCompleteShow.bind(this)
		this.handleChangeItemIssuedClick = this.handleChangeItemIssuedClick.bind(this)
		this.handleChangeItemReceivedClick = this.handleChangeItemReceivedClick.bind(this)
		this.handleClickItem = this.handleClickItem.bind(this)
		this.handleError = this.handleError.bind(this)
		this.handleCommentClick = this.handleCommentClick.bind(this)
		this.handleSaveReportClick = this.handleSaveReportClick.bind(this)
		this.handleCancel = this.handleCancel.bind(this)
		this.handleAttachTemplateClick = this.handleAttachTemplateClick.bind(this)
		this.handleUpdateComment = this.handleUpdateComment.bind(this)
		this.handle_ListItem_onCartClick = this.handle_ListItem_onCartClick.bind(this)

	}

	handleCancel() {
		this.setState({
			dialog: undefined
		})
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {() => {
//					this.update().then(() => {
						this.setState({
							dialog: undefined
						})
//					}, this.handleError)
				}}
			/>
		})
	}

	componentDidMount() {
		this.setState({
			show: this.props.show
		})
	}

	attachItem(show, item, amount) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("POST", config.restApiHost + `/show/${show.id}/item/${item.item_id ? item.item_id : item.id}/amount/${amount}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось добавить предмет.")
					}
				}
			}
			xhr.send()
		})
	}

	updateShowComment(show, comment) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/${show.id}/comment?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось обновить комментарий.")
					}
				}
			}
			xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
			xhr.send(JSON.stringify({
				comment: comment
			}))
		})
	}

	updateItemAmount(show, item, amount) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/${show.id}/item/${item.id}/amount/${amount}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось обновить данные предмета.")
					}
				}
			}
			xhr.send()
		})
	}

	removeItem(show, item) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("DELETE", config.restApiHost + `/show/${show.id}/item/${item.id}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось удалить предмет.")
					}
				}
			}
			xhr.send()
		})
	}

	updateItemIssued = async (show, item, issued) => {
		const response = await fetch(`${config.restApiHost}/show/${show.id}/item/${item.id}/issued/${issued}?sid=${Cookie.get("sid")}`, {method: "PUT"})
		return response.status === 200 ? await response.json() : Promise.reject(`Не удалось установить значение.`)
	}

	updateItemReceived(show, item, received) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/${show.id}/item/${item.id}/received/${received}?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось установить значение.")
					}
				}
			}
			xhr.send()
		})
	}

	completeShow(show) {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("PUT", config.restApiHost + `/show/${show.id}/complete/${show.completed == 1 ? 0 : 1 }?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						let json = JSON.parse(xhr.responseText)
						resolve(json)
					} else {
						reject("Не удалось завершить шоу.")
					}
				}
			}
			xhr.send()
		})
	}

	readyToComplete() {
		if (this.state.show) {
			for (let item of this.state.show.items) {
				if ((item.issued == 0) || (item.received == 0)) {
					return false
				}
			}
			return true
		} else {
			return false
		}
	}

	handleAttachItem() {
		this.setState({
			dialog: <SelectItemDialog
				onSelectItem = {item => {
					this.setState({
						dialog: <SetItemAmountDialog
							show = {this.state.show}
							item = {item}
							amount = "1"
							onSetAmount = {(show, item, amount) => {
								this.attachItem(show, item, amount).then(show => {
									this.setState({
										selected: this.getSelected(this.state.selected, show),
										show: show,
										dialog: undefined,
									})
								}, this.handleError)
							}}
							onCancel = {this.handleCancel}
						/>
					})
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleEditItem(item) {
		this.setState({
			dialog: <SetItemAmountDialog
				show = {this.state.show}
				item = {item}
				amount = {item.amount}
				onSetAmount = {(show, item, amount) => {
					this.updateItemAmount(show, item, amount).then(show => {
						this.setState({
							selected: this.getSelected(this.state.selected, show),
							show: show,
							dialog: undefined,
						})
					}, this.handleError)
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleRemoveItem(item) {
		this.setState({
			dialog: <DeleteItemDialog
				show = {this.state.show}
				item = {item}
				onDeleteItem = {(show, item) => {
					this.removeItem(show, item).then(show => {
						this.setState({
							selected: this.getSelected(this.state.selected, show),
							show: show,
							dialog: undefined,
						})
					}, this.handleError)
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleCompleteShow() {
		this.setState({
			dialog: <CompleteShowDialog
				show = {this.state.show}
				onCompleteShow = {(show, comment) => {
					this.updateShowComment(show, comment).then(show => {
						this.completeShow(show).then(show => {
							this.setState({
								selected: this.getSelected(this.state.selected, show),
								show: show,
								dialog: undefined,
							})
						}, this.handleError)
					}, this.handleError)
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleCommentClick(show) {
		this.setState({
			dialog: <CommentShowDialog
				show = {show}
				onCommentShow = {(show, comment) => {
					this.updateShowComment(show, comment).then(show => {
						this.setState({
							selected: this.getSelected(this.state.selected, show),
							show: show,
							dialog: undefined,
						})
					}, this.handleError)
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleChangeItemIssuedClick(item) {
		this.updateItemIssued(this.state.show, item, item.issued == 1 ? 0 : 1)
		 	.then(show => this.setState({show: show}))
		 	.catch(this.handleError)
	}

	handleChangeItemReceivedClick(item) {
		this.updateItemReceived(this.state.show, item, item.received == 1 ? 0 : 1).then(show => {
			this.setState({
				show: show
			})
		}, this.handleError)
	}

	handleClickItem(item) {
		if (this.state.selected) {
			if (this.state.selected.id === item.id) {
				this.handleEditItem(item)
				return
			}
		}
		this.setState({
			selected: item
		})
	}

	formatShowTime(date) {
		let t = (date.split(" ")[1]).split(":")
		return `${t[0]}:${t[1]}`
	}

	formatShowDate(date) {

		const monthNames = [
			"января",
			"февраля",
			"марта",
			"апреля",
			"мая",
			"июня",
			"июля",
			"августа",
			"сентября",
			"октября",
			"ноября",
			"декабря",
		]

		let spDate = (date.split(" ")[0]).split("-")
		let monthNumber = parseInt(spDate[1]) - 1

		return `${spDate[2]} ${monthNames[monthNumber]}`

	}

	getSelected(selected, show) {
		if (selected) {
			for (let item of show.items) {
				if (selected.id === item.id) {
					return item
				}
			}
		}
		return undefined
	}

	handleSaveReport(report) {
		let element = document.createElement("a")
		let data = new Blob(
			[`<!DOCTYPE html><html><head><meta charset = "utf-8"/></head><body>${report}</body></html>`],
			{type: 'text/html'}
		)
		element.href = URL.createObjectURL(data)
		element.download = "report.html"
		element.click()
	}

	handlePrintReport(report) {
		let printWindow = window.open("", "Печать отчета", "height=400,width=600")
		printWindow.document.write(`<!DOCTYPE html><html><head><meta charset = "utf-8"/></head><body>${report}</body></html>`)
		printWindow.document.close()
		printWindow.focus()
		printWindow.print()
		printWindow.close()
	}

	handleSaveReportClick(show) {
		this.setState({
			dialog: <ReportDialog
				show = {show}
				onSaveReport = {this.handleSaveReport}
				onPrintReport = {this.handlePrintReport}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleAttachTemplateClick() {

		const attachItemFromItems = (show, items, itemIndex, amount) => {
			return new Promise((resolve, reject) => {
				const item = items[itemIndex]
				if (item) {
					this.attachItem(show, item, item.amount * amount).then(
						show => {
							if (items[itemIndex + 1]) {
								attachItemFromItems(show, items, itemIndex + 1, amount).then(resolve)
							} else {
								resolve(show)
							}
						},
						reject
					)
				} else {
					resolve(this.state.show)
				}
			})
		}

		this.setState({
			dialog: <SelectTemplateDialog
				onSelectTemplate = {template => {
					this.setState({
						dialog: <TemplateAmountDialog
							template = {template}
							amount = {1}
							onSetAmount = {(template, amount) => {
								attachItemFromItems(this.state.show, template.items, 0, amount).then(
									show => {
										this.setState({
											selected: this.getSelected(this.state.selected, show),
											show: show,
											dialog: undefined,
										})
									},
									this.handleError
								)
							}}
							onCancel = {this.handleCancel}
						/>
					})
				}}
				onCancel = {this.handleCancel}
			/>
		})
	}

	handleUpdateComment(comment) {
		this.updateShowComment(this.state.show, comment).then(show => {
			this.setState({
				selected: this.getSelected(this.state.selected, show),
				show: show,
				dialog: undefined,
			})
		}, this.handleError)
	}

	handle_ListItem_onCartClick = item => {
		const itm = this.state.shopping_list.find(itm => itm.id === item.id)
		if (itm) {
			this.setState({shopping_list: this.state.shopping_list.filter(it => it.id !== itm.id)})
		} else {
			this.state.shopping_list.push(item)
			this.setState({shopping_list: this.state.shopping_list})
		}
	}

	render() {

		if (!this.state.show) {
			return null
		}

		return <Screen>

			{this.state.dialog}

			<PaperBlock style = {{display: "flex", flexDirection: "column", alignItems: "center"}}>
				<Typography>Шоу: {this.state.show ? this.state.show.name : ""}</Typography>
				<Typography variant="caption" color="textSecondary">{this.formatShowDate(this.state.show.date)} {this.formatShowTime(this.state.show.date)}</Typography>
				<Typography variant="caption" color="textSecondary">Адрес: {this.state.show.address}</Typography>
				{this.state.show.completed == 1 ? <Typography variant="caption" style = {{color: "red"}}>Шоу завершено</Typography> : null}
			</PaperBlock>

			<ControlPanel
				selected = {this.state.selected}
				show = {this.state.show}
				readyToComplete = {this.readyToComplete() && this.state.show.completed == 0}
				onAttachItemClick = {this.handleAttachItem}
				onAttachTemplateClick = {this.handleAttachTemplateClick}
				onEditItemAmountClick = {this.handleEditItem}
				onRemoveItemClick = {this.handleRemoveItem}
				onCompleteShowClick ={this.handleCompleteShow}
				onCommentClick = {this.handleCommentClick}
				onReportClick = {this.handleSaveReportClick}
			/>

			<ListItems
				items = {this.state.show.items}
				completed = {this.state.show.completed}
				selected = {this.state.selected}
				
				show_shopping_carts = {true}
				shopping_list = {this.state.shopping_list}

				onClickItem = {this.handleClickItem}
				onChangeItemIssuedClick = {this.handleChangeItemIssuedClick}
				onChangeItemReceivedClick = {this.handleChangeItemReceivedClick}
				onCartClick = {this.handle_ListItem_onCartClick}
			/>

			<CommentPanel
				comment={this.state.show.comment}
				onUpdate={this.handleUpdateComment}
			/>

			<div style = {{width: "100%", display: "flex", justifyContent: "flex-end"}}>

				<BottomButton
					variant = "contained"
					disabled = {!(this.state.shopping_list && this.state.shopping_list.length)}
					onClick={e=>{
						e.stopPropagation()
						this.setState({dialog: <SelectPurchaseTypeDialog 

							shopping_list = {this.state.shopping_list}

							onCreateClick = {shopping_list => {

								const date = new Date()
								const default_purchase_name = `${String(date.getDay()).padStart(2, "0")}-${String(date.getMonth()+1).padStart(2, "0")}-${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")} - ${this.props.show.name}`
		
								this.setState({dialog: <CreatePurchaseDialog 
									name = {default_purchase_name}
									onCreatePurchaseClick = {purchase => {
										api.purchases.create(purchase.name)
											.then(async response => {
												const purchase_id = response.id
												for(let item of shopping_list) {
													let response = await api.inventory.get(item.item_id)
													let itm = response.item
													let shop_id = itm.shops[0] ? itm.shops[0].id : undefined
													await api.purchases.attachments.create(purchase_id, item.item_id, item.amount, shop_id)
												}
												this.setState({
													shopping_list: [],
													dialog: undefined
												})
											})
											.catch(this.handleError)
									}}
									onCancelClick={() => this.setState({dialog: undefined})}
								/>})

							}}

							onSelectClick = {shopping_list => this.setState({dialog: <SelectPurchaseDialog 
								onSelectClick = {purchase => {
									const appendPurchases = async () => {
										const purchase_id = purchase.id
										for(let item of shopping_list) {
											let response = await api.inventory.get(item.item_id)
											let itm = response.item
											let shop_id = itm.shops[0] ? itm.shops[0].id : undefined
											await api.purchases.attachments.create(purchase_id, item.item_id, item.amount, shop_id)
										}
										this.setState({
											shopping_list: [],
											dialog: undefined
										})
									}
									appendPurchases().catch(this.handleError)
								}}
								onCancelClick = {() => this.setState({dialog: undefined})}
							/>})}

							onCancelClick = {() => this.setState({dialog: undefined})}

						/>})
					}}
				>Закупить</BottomButton>

				<BottomButton
					variant = "contained"
					color = "default"
					onClick = {e => {
						e.stopPropagation()
						this.handleCompleteShow()
					}}
				>{this.state.show.completed == 1 ? "Отменить завершение" : "Завершить сборку"}</BottomButton>

				<BottomButton
					variant = "contained"
					color = "default"
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onClose === "function") {
							this.props.onClose()
						}
					}}
				>Выход</BottomButton>

			</div>

		</Screen>

	}

}

export default ShowItemsScreen
